// import { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import BiniyogLogo from '../../../Assets/biniyog-logo.png'
import Khoj from '../../../../Assets/khojlogo.png'
import './Logo.css'
// import { APP_SETTINGS_API, IMAGE_URL } from '../../../../Utilities/APIs'

function Logo() {

    // const [logo, setLogo] = useState(null)

    
	
	// useEffect(() => {

    //     async function fetchData() {
    //         const res = await fetch(APP_SETTINGS_API);
    //         const data = await res.json();
    //         setLogo(data[0].image)
    //     }

	// 	fetchData()
        
	// }, [])
    
    return (
        <>
            {/* <Link to='/'> */}
                {/* {logo && <img src={IMAGE_URL + logo.slice(6,logo.length)} alt="logo" />} */}
                <img src={Khoj} alt='logo' className='logo'/>
            {/* </Link> */}
        </>
    )
}

export default Logo